import { CBMessagePreviewLibrary } from  'cb-message-builder'
var { avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark, headerPreview } = CBMessagePreviewLibrary

let assetTemplates =
[
    {
        'id': 'header',
        'title': 'Organization Image',
        'description': 'The organization image is used as a banner image in your profile. This image is required.',
        'required': true,
        'sizes': [{
            'placeholderTitle': null,
            'title': 'Institution Header',
            'altText' : 'The organization image is displayed in the banner section at the top of the screen on mobile devices',
            'id': 'header',
            'width': 2048,
            'height': 2048,
            'displayScale': 0.25,
            'primary': true,
            'previews': [headerPreview],
            'validations' : [
                {
                    // Return true or false
                    'check' : (asset) => { 
                        return fileExtension(asset.src) == 'png'
                    },

                    // Short title of validation
                    'title'       : 'File Format',

                    // Long description of validation
                    'description' : (asset) => { return `Organisation Image should be in png format, is ${fileExtension(asset.src)}` },

                    // Optional, if provided shows the validation when passed with this description
                    'validDescription' : 'Organisation Image is in the correct format',

                    // Optional to show the expected value for this validation.
                    'value'       : 'png'
                }
            ]
        }]
    },

    {
        'id': 'logo-avatar',
        'description': 'The square avatar logo is used to represent your organization in a condensed space. This logo is required.',
        'title': 'Logo - Square Avatar',
        'required': true,
        'sizes': [{
            'placeholderTitle': null,
            'title': 'Logo - Square Avatar',
            'altText' : 'The square avatar logo is displayed in the center of banner section at the top of the screen on mobile devices.',
            'id': 'logo-avatar',
            'width': 1024,
            'height': 1024,
            'aspectRatio': { numerator: 1, denominator: 1 },
            'displayScale': 0.25,
            'primary': true,
            'previews': [avatarPreviews]
        }]
    },

    {
        'id': 'logo',
        'title': 'Logo - Wordmark',
        'description': 'The optional wordmark logo is used to represent your organization in larger spaces.- ',
        'sizes': [{
            'placeholderTitle': 'Light',
            'title': 'Logo Wordmark - Light',
            'altText' : 'The light wordmark logo is displayed at the top of a message card that is contained in a list.',
            'id': 'logo-wordmark-light',
            'width': 2048,
            'height': 512,
            'displayScale': 0.25,
            'variableWidth': true,
            'checkContrast': true,
            'primary': true,
            'previews': [wordmarkPreviewsLight]
        },
        {
            'placeholderTitle': 'Dark',
            'altText' : 'The dark wordmark logo is displayed at the top of a message card that is contained in a list.',
            'title': 'Logo - Wordmark - Dark',
            'id': 'logo-wordmark-dark',
            'width': 2048,
            'height': 512,
            'displayScale': 0.25,
            'variableWidth': true,
            'primary': true,
            'dark': true,
            'previews': [wordmarkPreviewsDark]
        }
        ]
    },
]

function fileExtension(url) {
    // Extract the pathname from the URL
    let pathname = new URL(url).pathname;
    
    // Split the pathname by '.' and get the last part
    let parts = pathname.split('.');
    return parts.length > 1 ? parts.pop() : null;
}

export default assetTemplates